export default (options = {}) => ({
    THEME_COLORS: {
        'contrastspectrum-minus-min': '#F33326',
        'contrastspectrum-minus-100': '#FF574D',
        'contrastspectrum-minus-75': '#FB9595',
        'contrastspectrum-minus-50': '#FBADAD',
        'contrastspectrum-minus-25': '#F9CACA',
        'contrastspectrum-plus-max': '#03D500',
        'contrastspectrum-plus-25': '#C5F6C4',
        'contrastspectrum-plus-50': '#A1F1A0',
        'contrastspectrum-plus-75': '#71EA6F',
        'contrastspectrum-plus-100': '#49E047',
        'mutedlagoon-minus-min': '#774305',
        'mutedlagoon-minus-100': '#8C510A',
        'mutedlagoon-minus-75': '#BF812D',
        'mutedlagoon-minus-50': '#DFC27D',
        'mutedlagoon-minus-25': '#F6E8C3',
        'mutedlagoon-plus-max': '#004F49',
        'mutedlagoon-plus-25': '#C7EAE5',
        'mutedlagoon-plus-50': '#80CDC1',
        'mutedlagoon-plus-75': '#35978F',
        'mutedlagoon-plus-100': '#01665E',
        'rosyverdant-minus-min': '#B0106C',
        'rosyverdant-minus-100': '#C51B7D',
        'rosyverdant-minus-75': '#DE77AE',
        'rosyverdant-minus-50': '#F1B6DA',
        'rosyverdant-minus-25': '#FDE0EF',
        'rosyverdant-plus-max': '#3A810D',
        'rosyverdant-plus-25': '#E6F5D0',
        'rosyverdant-plus-50': '#B8E186',
        'rosyverdant-plus-75': '#7FBC41',
        'rosyverdant-plus-100': '#4D9221',
        'mauvemeadow-minus-min': '#63226E',
        'mauvemeadow-minus-100': '#762A83',
        'mauvemeadow-minus-75': '#9970AB',
        'mauvemeadow-minus-50': '#C2A5CF',
        'mauvemeadow-minus-25': '#E7D4E8',
        'mauvemeadow-plus-max': '#0F6D2C',
        'mauvemeadow-plus-25': '#D9F0D3',
        'mauvemeadow-plus-50': '#A6DBA0',
        'mauvemeadow-plus-75': '#5AAE61',
        'mauvemeadow-plus-100': '#1B7837',
        'ambertwilight-minus-min': '#8E4707',
        'ambertwilight-minus-100': '#B35806',
        'ambertwilight-minus-75': '#E08214',
        'ambertwilight-minus-50': '#FDB863',
        'ambertwilight-minus-25': '#FEE0B6',
        'ambertwilight-plus-max': '#45157D',
        'ambertwilight-plus-25': '#D8DAEB',
        'ambertwilight-plus-50': '#B2ABD2',
        'ambertwilight-plus-75': '#8073AC',
        'ambertwilight-plus-100': '#542788',
        'crimsonazure-minus-min': '#9B0A1C',
        'crimsonazure-minus-100': '#B2182B',
        'crimsonazure-minus-75': '#D6604D',
        'crimsonazure-minus-50': '#F4A582',
        'crimsonazure-minus-25': '#FDDBC7',
        'crimsonazure-plus-max': '#14579B',
        'crimsonazure-plus-25': '#D4E6F0',
        'crimsonazure-plus-50': '#92C5DE',
        'crimsonazure-plus-75': '#4393C3',
        'crimsonazure-plus-100': '#2166AC',
        'emberocean-minus-min': '#D2190F',
        'emberocean-minus-100': '#D73027',
        'emberocean-minus-75': '#F46D43',
        'emberocean-minus-50': '#FDAE61',
        'emberocean-minus-25': '#FEE090',
        'emberocean-plus-max': '#2062B8',
        'emberocean-plus-25': '#E1F3F8',
        'emberocean-plus-50': '#B5DDEB',
        'emberocean-plus-75': '#74ADD1',
        'emberocean-plus-100': '#4575B4',
        // Diverging scales derived from the Superset chart palettes (same theme names color
        // dashboard charts). Anchors: the palette's negative/positive series colors; in-between
        // stops interpolated toward a near-white middle. Locked to the PHP enum by
        // tests/Unit/SupersetChartPaletteDriftTest.
        'nsqdark-minus-min': '#D27979',
        'nsqdark-minus-100': '#EF8A8A',
        'nsqdark-minus-75': '#F2ACA9',
        'nsqdark-minus-50': '#F4C6C1',
        'nsqdark-minus-25': '#F6DCD6',
        'nsqdark-plus-max': '#54B67D',
        'nsqdark-plus-25': '#D1EDDE',
        'nsqdark-plus-50': '#B1E5C8',
        'nsqdark-plus-75': '#8EDCAF',
        'nsqdark-plus-100': '#5FCF8E',
        'futurereadycfo-minus-min': '#C27528',
        'futurereadycfo-minus-100': '#DD852D',
        'futurereadycfo-minus-75': '#E6A96B',
        'futurereadycfo-minus-50': '#EDC49A',
        'futurereadycfo-minus-25': '#F3DBC3',
        'futurereadycfo-plus-max': '#004956',
        'futurereadycfo-plus-25': '#BED5D5',
        'futurereadycfo-plus-50': '#89B1B6',
        'futurereadycfo-plus-75': '#4E8892',
        'futurereadycfo-plus-100': '#005362',
        'futurereadycfohighcontrast-minus-min': '#C27528',
        'futurereadycfohighcontrast-minus-100': '#DD852D',
        'futurereadycfohighcontrast-minus-75': '#E6A96B',
        'futurereadycfohighcontrast-minus-50': '#EDC49A',
        'futurereadycfohighcontrast-minus-25': '#F3DBC3',
        'futurereadycfohighcontrast-plus-max': '#5E858D',
        'futurereadycfohighcontrast-plus-25': '#D3E2E2',
        'futurereadycfohighcontrast-plus-50': '#B6CED0',
        'futurereadycfohighcontrast-plus-75': '#96B6BB',
        'futurereadycfohighcontrast-plus-100': '#6B97A0',
    },
    
    WHITE_TEXT_BACKGROUNDS: [
        'mutedlagoon-minus-min',
        'mutedlagoon-minus-100',
        'mutedlagoon-plus-100',
        'mutedlagoon-plus-max',
        'rosyverdant-minus-min',
        'rosyverdant-minus-100',
        'mauvemeadow-minus-min',
        'mauvemeadow-minus-100',
        'mauvemeadow-plus-100',
        'mauvemeadow-plus-max',
        'ambertwilight-minus-min',
        'ambertwilight-minus-100',
        'ambertwilight-plus-100',
        'ambertwilight-plus-max',
        'crimsonazure-minus-min',
        'crimsonazure-minus-100',
        'crimsonazure-plus-100',
        'crimsonazure-plus-max',
        'emberocean-minus-min',
        'emberocean-minus-100',
        'emberocean-plus-100',
        'emberocean-plus-max',
        'rosyverdant-plus-max',
        'futurereadycfo-plus-100',
        'futurereadycfo-plus-max'
    ],
    
    // Cache for computed styles
    styleCache: {},

    /**
     * Clear style cache for a specific metric
     * Call this when metric goals change to force style recalculation
     */
    clearMetricStyleCache(metricId) {
        if (!metricId) return;
        
        const keysToDelete = [];
        for (const key in this.styleCache) {
            if (key.startsWith(`${metricId}-`)) {
                keysToDelete.push(key);
            }
        }
        
        keysToDelete.forEach(key => delete this.styleCache[key]);
    },
    
    // Translated by Blade at the call site (this module has no translator). The English fallbacks
    // keep the cue present if the mixin is ever spread without options.
    recordLabels: {
        high: options.recordLabels?.high ?? 'All-time high',
        low: options.recordLabels?.low ?? 'All-time low',
    },

    /**
     * Which all-time record a value holds: 'high', 'low', or '' for none.
     *
     * Bolding a record used to be gated on the metric's goal, twice over: getCellStyle() returned
     * early when the metric had no goal, and otherwise bolded a record only when it fell on one
     * side of the goal line — so a best-ever value that still missed its goal, and a worst-ever
     * value that still cleared it, printed as ordinary text. On a production export of scorecard 24
     * that silenced 97 of 719 records. A record is a record; goal status is already carried by the
     * cell's colour, icon or shape, and is not what this weight is for.
     *
     * The comparison is on raw_value, never on the rounded number the cell prints. The printed
     * value and the printed min/max round independently, so any period that happened to round to
     * the record's display value was bolded alongside the real record — 31.06 and 31.17 both print
     * "31", and that alone put bold on 30 non-record cells of scorecard 24.
     */
    getRecordKind(metric, interval, rawValue) {
        if (rawValue === null || rawValue === undefined) return '';

        const tooltip = metric?.tooltips?.[interval];
        const min = tooltip?.min;
        const max = tooltip?.max;
        if (min === null || min === undefined || max === null || max === undefined) return '';

        /* A flat series (min === max) holds no record: every period carries the same number, so
         * nothing stands out and bolding the whole row says nothing. Scorecard 24 has 9 such
         * series — 35 daily cells of "SSA: New 5-Star Reviews", all zero, among them. */
        if (min === max) return '';

        if (rawValue === max) return 'high';
        if (rawValue === min) return 'low';
        return '';
    },

    /**
     * The record a rendered cell holds, for every partial that asks — the weight, the sr-only label
     * and the colour-theme style all come through here, so they cannot disagree.
     *
     * The period still in progress is never a record. It is excluded from min/max upstream
     * (ScorecardService::filterCurrentValuesForMinMaxCalculations) because a partial period is not
     * comparable with complete ones — but its running value can still equal one of them by chance
     * (a count whose all-time low is 0, two days into a month with nothing counted yet), and that
     * cell used to bold. The header decides here, not the caller: a projection, a fallback to the
     * running value and a completed period all take the same test.
     */
    getCellRecordKind(row, headerData) {
        if (headerData.isPlaceholder) return '';

        const interval = this.activeInterval;
        if (interval !== headerData.interval) return '';
        if (this.isHeaderCurrentPeriod(headerData)) return '';

        const metric = this.fullScorecardData?.metrics?.[row.metric_id];
        if (!metric) return '';

        const cell = metric.data?.[interval]?.[headerData.start_date];
        return this.getRecordKind(metric, interval, cell?.raw_value ?? null);
    },

    /**
     * Record weight on its own, for the icons and shapes cells.
     *
     * Those partials never called getCellStyle at all, so for anyone whose profile theme is
     * "Shapes & Icons" the all-time record highlight did not exist — not partially missing, simply
     * absent on every cell of every scorecard. They take the weight alone rather than the whole
     * style: the background colours getCellStyle can also return belong to the colour themes, and
     * isScorecardVisualsTheme is false in exactly these two modes.
     */
    getCellRecordWeight(row, headerData) {
        return this.getCellRecordKind(row, headerData) ? 'font-weight: 900' : '';
    },

    /**
     * The record as text assistive technology can read (WCAG 1.3.1). The weight is an inline style,
     * which a screen reader never announces, so without this a record cell reads exactly like its
     * neighbours. getCellValueContent() appends it to the value in every theme.
     */
    getCellRecordLabel(row, headerData) {
        const kind = this.getCellRecordKind(row, headerData);
        return kind ? `<span class="sr-only"> ${this.recordLabels[kind]}</span>` : '';
    },

    getCellStyle(row, headerData, useProjected = false) {
        if (headerData.isPlaceholder) return '';
        
        const interval = this.activeInterval;
        if (interval !== headerData.interval) return '';

        const metricId = row.metric_id;
        const startDate = headerData.start_date;
        const visualIndicator = this.activeTab?.settings?.visual_indicator || 'color';
        const cacheKey = `${metricId}-${interval}-${startDate}-${visualIndicator}`;
        
        // Only use cache for non-projected values
        if (!useProjected) {
            if (this.styleCache[cacheKey] !== undefined) {
                return this.styleCache[cacheKey];
            }
        }
        
        const metric = this.fullScorecardData?.metrics?.[metricId];
        if (!metric) {
            if (!useProjected) this.styleCache[cacheKey] = '';
            return '';
        }
        
        let data = null;
        let value = null;
        
        // Check for projected value first if requested
        if (useProjected) {
            const projectedData = metric.projected?.[interval];
            // Only use projected if it belongs to this exact period
            if (projectedData && projectedData.start_date === startDate) {
                value = projectedData.value;
                data = { no_seperators_or_labels_formatted_value: value };
            }
            
            // Fallback to current value if projected not found and fallback is enabled
            if (!data) {
                data = metric.data?.[interval]?.[startDate];
                if (data) {
                    value = data.no_seperators_or_labels_formatted_value;
                }
            }
        } else {
            // Use current/regular value
            data = metric.data?.[interval]?.[startDate];
            if (data) {
                value = data.no_seperators_or_labels_formatted_value;
            }
        }
        
        if (!data) {
            if (!useProjected) this.styleCache[cacheKey] = '';
            return '';
        }
        
        if (value === undefined || value === null) {
            if (!useProjected) this.styleCache[cacheKey] = '';
            return '';
        }
        
        const goal = metric.goals?.[interval];
        const goal_value = goal?.goal_value ?? null;
        const goal_criteria = goal?.goal_criteria ?? null;
        const hasGoal = goal_value !== null && goal_value !== undefined;
        
        const cssProperties = [];
        
        /* Bold marks an all-time record, judged by getCellRecordKind() from the cell's raw value and
         * its header — not from `value`, which is the ROUNDED number the cell prints, and not from
         * the goal, which used to gate it (see getRecordKind). The colour band below still derives
         * from `value`: a band computed from the displayed number is what the reader sees. */
        const recordWeight = this.getCellRecordWeight(row, headerData);
        if (recordWeight) {
            cssProperties.push(recordWeight);
        }

        // Visual theming - only apply background colors when visualIndicator is 'color'
        if (hasGoal && this.isScorecardVisualsTheme && visualIndicator === 'color') {
            const spectrum = this.getVisualsSpectrum(value, goal_value, goal_criteria);
            const percentage = this.getPercentageRange(goal_value, value);
            const background = `${this.scorecard_visuals}-${spectrum}-${percentage}`;
            const text_color = this.getTextColor(background);

            const bgColor = this.THEME_COLORS[background];
            if (bgColor) {
                cssProperties.push(`background-color: ${bgColor}`);
                cssProperties.push(`color: ${text_color}`);
            }
        }

        const result = cssProperties.join('; ');
        
        // Cache result for non-projected values
        if (!useProjected) {
            this.styleCache[cacheKey] = result;
        }
        
        return result;
    },
    
    getVisualsSpectrum(value, goal_value, goal_criteria) {
        let spectrum = this.isScorecardVisualsTheme ? 'minus' : 'low';
        switch (goal_criteria) {
            case 'less_than_or_equal':
                if (value <= goal_value) {
                    spectrum = this.isScorecardVisualsTheme ? 'plus' : 'high';
                }
                break;
            case 'greater_than_or_equal':
                if (value >= goal_value) {
                    spectrum = this.isScorecardVisualsTheme ? 'plus' : 'high';
                }
                break;
        }
        return spectrum;
    },
    
    getPercentageRange(goal, value) {
        if (value === null || value === undefined || isNaN(value)) {
            value = 0;
        }
        if (goal === null || goal === undefined || isNaN(goal) || goal == 0) {
            goal = 1;
        }
    
        let percentage = (value / goal) * 100;
        percentage = Math.abs(percentage - 100);
    
        if (percentage <= 25) {
            return '25';
        } else if (percentage <= 50) {
            return '50';
        } else if (percentage <= 75) {
            return '75';
        } else {
            return '100';
        }
    },
    
    getTextColor(background) {
        if (this.WHITE_TEXT_BACKGROUNDS.includes(background)) {
            return 'white';
        }
        return 'black';
    }
});
